/*********************************
 ****** REACT CONFIGURATION ******
 *********************************/
import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { HashRouter } from "react-router-dom";
import reportWebVitals from "reportWebVitals";
/*********************************
 ****** REDUX CONFIGURATION ******
 *********************************/
import { Provider } from "react-redux";
import { GoogleOAuthProvider } from "@react-oauth/google";
import store from "store";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
/*****************
 ****** CSS ******
 *****************/
//@ts-ignore
import "index.css";

import App from "App";
import {
  AuthProvider,
  ModalCoordinatorProvider,
  NotificationProvider,
  OrganizationsProvider,
  ThemeModeProvider,
  UtilityProvider,
} from "contexts";
import "cronstrue/locales/it";
import "cronstrue/locales/en";
import "cronstrue/locales/es";
import dayjs from "dayjs";
import "dayjs/locale/it";
import "dayjs/locale/en";
import "dayjs/locale/de";
import "dayjs/locale/es";
import "dayjs/locale/es-pr";
import isBetween from "dayjs/plugin/isBetween"
import duration from "dayjs/plugin/duration";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

// Stripe: use the /pure import so the SDK script is NOT injected and r.stripe.com/b beacon
// is NOT fired on every page load. loadStripe is called lazily only when billing screens need it.
import { loadStripe } from "@stripe/stripe-js/pure";
export const getStripePromise = (() => {
  let promise: ReturnType<typeof loadStripe> | null = null;
  return () => {
    if (!promise) {
      promise = loadStripe(process.env.REACT_APP_STRIPE_DEVELOP_API_KEY || "");
    }
    return promise;
  };
})();
// console.log(stripePromise)

dayjs.extend(duration);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isBetween)

const persistor = persistStore(store);

const rootElement = document.getElementById("root") as HTMLElement;
// expose store when run in Cypress
if ((window as any).Cypress) {
  (window as any).store = store;
}

// process.env.REACT_APP_GOOGLE_CLIENT_ID ||
const app = (
  // <React.StrictMode>
  <ThemeModeProvider>
    <GoogleOAuthProvider
      clientId={
        process.env.REACT_APP_GOOGLE_CLIENT_ID2 || ""
      }
    >
      <AuthProvider>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <OrganizationsProvider>
              <UtilityProvider>
                <ModalCoordinatorProvider>
                  <NotificationProvider>
                    <HashRouter>
                        <App />
                    </HashRouter>
                  </NotificationProvider>
                </ModalCoordinatorProvider>
              </UtilityProvider>
            </OrganizationsProvider>
          </PersistGate>
        </Provider>
      </AuthProvider>
    </GoogleOAuthProvider>
  </ThemeModeProvider>
  // </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
